import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (username, password) => api.post('/auth/login', { username, password });
export const getProfile = () => api.get('/auth/profile');
export const changePassword = (currentPassword, newPassword) => 
  api.post('/auth/change-password', { currentPassword, newPassword });

// Companies
export const getCompanies = () => api.get('/companies');
export const getCompany = (id) => api.get(`/companies/${id}`);
export const getCompanySummary = (id, month) => api.get(`/companies/${id}/summary`, { params: { month } });

// Transactions
export const getTransactions = (params) => api.get('/transactions', { params });
export const getTransaction = (id) => api.get(`/transactions/${id}`);
export const getTransactionTypes = () => api.get('/transactions/types');

// Dashboard
export const getDashboardSummary = (month) => api.get('/dashboard/summary', { params: { month } });
export const getIncomeBreakdown = (month) => api.get('/dashboard/income-breakdown', { params: { month } });
export const getMonthlyTrend = () => api.get('/dashboard/monthly-trend');

// Salary
export const calculateSalary = (month, salaryPercentage) => 
  api.get('/salary/calculate', { params: { month, salaryPercentage } });
export const getSalaryHistory = (userId) => api.get(`/salary/history/${userId}`);
export const saveSalaryCalculation = (data) => api.post('/salary/save', data);

export default api;
